import CheckoutBox from '../../../components/core/CheckoutBox/CheckoutBox';
import { ReactNode, useMemo } from 'react';
import { ILineItem } from '../../../contexts/CartContext/CartContext.types';
import SimpleLineCard from '../Cards/SimpleLine/SimpleLineCard';
import useMonthlyPaymentContractStyles from '../ServiceContracts/MonthlyPaymentContract/MonthlyPaymentContract.styles';
import { useCart } from '../../../contexts/CartContext/CartContext.hooks';
import PhoneNumberInputValidate from './PhoneNumberInputValidate/PhoneNumberInputValidate';
import GetByodPhoneNumbers, {
    IByodPhoneNumberGrouping
} from './PhoneNumberInputValidate/PhoneNumberInputValidate.api';

const PickNumber = () => {
    const styles = useMonthlyPaymentContractStyles();

    const { cart } = useCart();

    const validPhoneNumbers: IByodPhoneNumberGrouping[] = useMemo(() => {
        const phoneNumberArray: IByodPhoneNumberGrouping[] = [];
        GetByodPhoneNumbers(
            (phoneNumbers: IByodPhoneNumberGrouping[]) => {
                phoneNumbers.forEach((phoneNumber) => {
                    phoneNumberArray.push(phoneNumber);
                });
            },
            () => {
                console.log('Unable to get BYOD phone number groupings.');
            }
        );
        return phoneNumberArray;
    }, [cart]);

    const lineCards: ReactNode[] = useMemo(
        () =>
            cart.lineItems.map((lineItem: ILineItem) => (
                <SimpleLineCard key={`line-card-${lineItem.lineNumber}`} item={lineItem}>
                    <div className={styles.simpleLineCardWrapper}>
                        <PhoneNumberInputValidate
                            validPhoneNumberGroups={validPhoneNumbers}
                            lineItem={lineItem}
                        />
                    </div>
                </SimpleLineCard>
            )),
        [cart.lineItems]
    );

    return <CheckoutBox header='Pick Your Phone Number'>{lineCards}</CheckoutBox>;
};

export default PickNumber;
